export const START_ALERT = 'START_ALERT';
export const END_ALERT = 'END_ALERT';

export function startAlert(alertSpec) {
    return { type: START_ALERT, alert: alertSpec };
}

export function endAlert(result) {
    return { type: END_ALERT, result };
}
